<div>
    <button class="btn btn-primary btn-sm btn--menu ms-2" (click)="openFormlerModal()">Formler</button>
</div>
